import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "className", "style"];
import React from 'react';
import { Card } from 'semantic-ui-react';
import Author from './components/Author';
import Image from './components/Image';
import Line from './components/Line';
import Rating from './components/Rating';
import RatingLabel from './components/RatingLabel';
import Source from './components/Source';
import Text from './components/Text';
import { StylePropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import useSemanticUiProps from '../../../foundation/hooks/use-semantic-ui-props/use-semantic-ui-props';
import { ChildrenPropType } from '../../../foundation/types/component';
import './Review.css';
var defaultProps = {
  children: null,
  content: null,
  className: '',
  style: {}
};
export default function Review(_ref) {
  var children = _ref.children,
    content = _ref.content,
    className = _ref.className,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(),
    getCardProps = _useSemanticUiProps.getCardProps;
  var cardProps = getCardProps(rest);
  var finalContent = content || children;
  var finalClassName = classNames(_defineProperty({
    review: true
  }, className, className));
  return /*#__PURE__*/React.createElement(Card, _extends({
    className: finalClassName,
    style: style
  }, cardProps), /*#__PURE__*/React.createElement(Card.Content, null, finalContent));
}
Review.defaultProps = defaultProps;
Review.Line = Line;
Review.Image = Image;
Review.Text = Text;
Review.Rating = Rating;
Review.RatingLabel = RatingLabel;
Review.Author = Author;
Review.Source = Source;